import { render, staticRenderFns } from "./DeleteTemplateEmployeeSalary.vue?vue&type=template&id=40e0263a&scoped=true"
import script from "./DeleteTemplateEmployeeSalary.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateEmployeeSalary.vue?vue&type=script&lang=js"
import style0 from "./DeleteTemplateEmployeeSalary.vue?vue&type=style&index=0&id=40e0263a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e0263a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e0263a')) {
      api.createRecord('40e0263a', component.options)
    } else {
      api.reload('40e0263a', component.options)
    }
    module.hot.accept("./DeleteTemplateEmployeeSalary.vue?vue&type=template&id=40e0263a&scoped=true", function () {
      api.rerender('40e0263a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/employeeSalary/employeeSalarySearchDialog/DeleteTemplateEmployeeSalary.vue"
export default component.exports